<!-- ISS-032: which system this is (development / beta / ...), on every screen off the live system. -->
<newgenus-environment-banner></newgenus-environment-banner>
<mat-drawer-container class="app-root-container" [ngClass]="{ 'h-100': !auth.isLoggedIn && !isUserInstantiated }">
    <!-- Over laying menu content. -->
    <mat-drawer (openedStart)="hasBackDrop = true" #drawer mode="over" role="navigation">
        <section class="app-nav-list">
            <mat-selection-list
                [(ngModel)]="selectedOptions"
                id="main-nav-list"
                (selectionChange)="onMainNavSelect($event); drawer.toggle()"
                [multiple]="false"
                hideSingleSelectionIndicator="true"
            >
                <!-- Main navigation menu items. -->
                <mat-list-option *ngFor="let item of navigationOptions" [value]="item">
                    <mat-icon mat-list-icon>{{ item.icon }}</mat-icon>
                    <div mat-line>{{ item.name }}</div>
                </mat-list-option>
            </mat-selection-list>
        </section>
    </mat-drawer>

    <!-- Dynamic template sidebar. -->
    <!-- @.disabled on phones: Material's own drawer animation moves an
         end-drawer sideways and toggles `.mat-drawer-opened` only when it
         finishes, so the sheet presentation never animated — the panel simply
         vanished. With it disabled the class flips immediately and the CSS
         transition in app.component.scss slides the panel down off the bottom
         edge (OE-162). Desktop keeps Material's animation. -->
    <mat-drawer
        #drawerSecondary
        [@.disabled]="isSmallDisplay"
        position="end"
        (openedStart)="hasBackDrop = false; sidebarService.markAsOpened(); clearSidebarDragStyles()"
        (closedStart)="sidebarService.markAsClosed()"
        [mode]="sidebarService.sidebarMode"
        class="min-w30-overflow-x-hidden"
    >
        <!-- Grab handle: phones present this panel as a bottom sheet, so it
             carries the same pill and drag-down-to-dismiss as every other
             sheet (DESIGN.md §Sheets). Hidden on desktop, where the panel is
             a side drawer. -->
        <div
            class="ng-sheet-grab sidebar-grab"
            ngSheetDrag
            ngSheetDragContainer="mat-drawer[position=end]"
            (ngSheetDragDismissed)="closeSidebarPanel()"
            aria-hidden="true"
        ></div>

        <!-- Close button -->
        <div style="display: flex; padding: 0.5rem; justify-content: space-between">
            <button mat-icon-button (click)="drawerSecondary.toggle()">
                <mat-icon>close</mat-icon>
            </button>

            <!-- Toggle to change the mode of the drawer. Desktop only: on a
                 phone the panel is a bottom sheet, where side/over means
                 nothing (OE-162). -->
            <button
                mat-icon-button
                class="drawer-mode-toggle"
                (click)="drawerSecondary.mode = drawerSecondary.mode === 'over' ? 'side' : 'over'"
            >
                <mat-icon>swap_horiz</mat-icon>
            </button>
        </div>

        <mat-divider></mat-divider>

        <!-- Example content. Replace with template-based functionality for flexible side-bar behaviour. -->
        <ng-container *ngIf="!sidebarService.templateRef; else renderTemplate">
            <ng-container *ngTemplateOutlet="exampleTemplate"></ng-container>
        </ng-container>
        <ng-template #renderTemplate>
            <!-- Template with data. -->
            <ng-container *ngIf="sidebarService.templateData; else sidebarService.templateRef">
                <ng-container
                    *ngTemplateOutlet="sidebarService.templateRef; context: { $implicit: sidebarService.templateData }"
                ></ng-container>
            </ng-container>
        </ng-template>

        <!-- <ng-container *ngTemplateOutlet="exampleTemplate"></ng-container> -->
    </mat-drawer>

    <!-- The entire App's content. -->
    <mat-drawer-content>
        <!-- Header Component -->
        <nav
            class="app-header-nav"
            *ngIf="auth.isLoggedIn && isUserInstantiated && showHeader"
            [@smoothHeight]
            [@delayedOpacity]
        >
            <newgenus-header
                [hats]="this.hats"
                [settings]="this.settings"
                (toggle)="drawer.toggle()"
                (secondSidenavToggle)="drawerSecondary.toggle()"
            ></newgenus-header>
        </nav>

        <!-- Focus Button -->
        <button
            class="sub-menu-expand"
            *ngIf="showFocusBtn && auth.isLoggedIn && isUserInstantiated"
            [ngClass]="{
                'completely-open': subNavSidebarState === 'expanded' && innerMenu.opened,
                'rather-closed': subNavSidebarState === 'collapsed' && innerMenu.opened,
                'completely-closed': !innerMenu.opened,
            }"
            mat-mini-fab
            color="secondary"
            aria-label="Expand Menu"
            role="button"
            (click)="innerMenu.toggle(); toggleFocusMode()"
        >
            <mat-icon style="line-height: 20px">{{
                innerMenu.opened ? 'keyboard_arrow_left' : 'keyboard_arrow_right'
            }}</mat-icon>
        </button>

        <mat-drawer-container
            #innerMenuContainer
            [ngClass]="{ 'height-less-header': auth.isLoggedIn && isUserInstantiated && showHeader }"
        >
            <!-- The sub-directory navigation menu. On phones (≤767.98px) it is
                 retired via CSS (.side-menu-drawer) in favour of the bottom bar +
                 Menu sheet; on desktop it renders exactly as before. -->
            <mat-drawer mode="side" opened #innerMenu class="side-menu-drawer">
                <div
                    *ngIf="auth.isLoggedIn && isUserInstantiated"
                    class="sidebar-container"
                    [ngClass]="{
                        'mobile-display': isSmallDisplay === true,
                        collapsed: subNavSidebarState === 'collapsed',
                        expanded: subNavSidebarState === 'expanded',
                    }"
                >
                    <newgenus-sidebar
                        [ngClass]="{
                            'd-flex h-100': auth.isLoggedIn && isUserInstantiated,
                            'd-none': !(auth.isLoggedIn && isUserInstantiated),
                        }"
                    ></newgenus-sidebar>
                </div>
            </mat-drawer>

            <!-- The app's content. -->
            <mat-drawer-content>
                <div class="app-content-pane" [class.app-content-pane--handset]="breakpointService.isHandset$ | async">
                    <!-- <ng-container *ngIf="loadingRouteConfig">Loading route config...</ng-container> -->
                    <flash-messages></flash-messages>
                    <router-outlet></router-outlet>
                </div>
            </mat-drawer-content>
        </mat-drawer-container>

        <!-- Phone primary navigation: a customisable bottom bar (user favourites
             + a "Menu" slot that opens the full sections→items sheet). Shown at the
             small-display breakpoint (≤767.98px); the sidebar is retired on phones. -->
        <newgenus-mobile-bottom-nav
            *ngIf="auth.isLoggedIn && isUserInstantiated && (breakpointService.isSmallDisplay$ | async)"
            [items]="mobileBarItems"
            [selectedId]="mobileSelectedId"
            (itemSelected)="onMobileNavSelect($event)"
        ></newgenus-mobile-bottom-nav>
    </mat-drawer-content>
</mat-drawer-container>

<ng-template #exampleTemplate>
    <!-- Placeholder content for empty sidebar state -->
    <div style="display: flex; flex: 1 auto; padding: 0.5rem; flex-direction: column"></div>
</ng-template>
